import React, { useMemo } from 'react';
import { Body2 } from '@/ui';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter, dateString, displayFullDate } from '@/utils/helpers';
import styled from 'styled-components';
import { Steps, Modal, Flex } from 'antd';
import { COLORS } from '@/utils/static';

export const HistoryModal = ({
  active,
  onClose,
  answers,
  answersOld,
  availableAnswers,
  questionTitle,
  questionType
}) => {
  const { t } = useTranslation();

  const answersList = useMemo(() => {
    if (!answers || answers.length === 0) return [];

    return answers.map((item) => {
      const answer =
        item.answer ?? availableAnswers.find((i) => i.id === item.availableAnswerId)?.answer;
      const creator = item.creatorAdmin
        ? t('created by administrator')
        : item.creator
          ? `${t('created by')} ${item.creator.firstName} ${item.creator.lastName}`
          : t('created by investor');

      if (answer) {
        return {
          title: questionType === 'DATE' ? dateString(new Date(answer)) : answer,
          description: (
            <>
              <span>
                {t('Actual')}, {creator}
              </span>
              <span style={{ color: COLORS.aragonDarkBlue }}>
                {' '}
                ({displayFullDate(new Date(item.createdAt))})
              </span>
            </>
          )
        };
      } else {
        return {};
      }
    });
  }, [answers]);

  const answersOldList = useMemo(() => {
    if (!answersOld || answersOld.length === 0) return [];

    return answersOld
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .map((item) => {
        const answer =
          item.answer ?? availableAnswers.find((i) => i.id === item.availableAnswerId)?.answer;
        const creator = item.creatorAdmin
          ? t('created by administrator')
          : item.creator
            ? `${t('created by')} ${item.creator.firstName} ${item.creator.lastName}`
            : t('created by investor');

        if (answer) {
          return {
            title: questionType === 'DATE' ? dateString(new Date(answer)) : answer,
            description: (
              <>
                <span>{capitalizeFirstLetter(creator)}</span>
                <span style={{ color: COLORS.aragonDarkGreyBlue }}>
                  {' '}
                  ({displayFullDate(new Date(item.createdAt))})
                </span>
              </>
            )
          };
        } else {
          return {};
        }
      });
  }, [answersOld]);

  return (
    <Modal open={active} onCancel={onClose} style={{ zIndex: '999' }} footer={null}>
      <Flex vertical>
        <Body2 fontWeight={500} marginBottom={10}>
          {t('History of answers for question')}
        </Body2>
        <Body2>'{questionTitle}':</Body2>
      </Flex>

      <Wrapper>
        <Steps
          progressDot
          direction='vertical'
          current={answersList.length - 1}
          items={[...answersList, ...answersOldList]}
        />
      </Wrapper>
    </Modal>
  );
};

const Wrapper = styled.div`
  margin-top: 15px;
`;
